package dev.kotlinfest._2026.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initStaffRecruitmentPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("StaffRecruitment.md", FrontMatterElement.Builder { addScalar("title", "当日スタッフ募集"); addScalar("description", "Kotlin Fest 2026の当日スタッフ募集は終了しました。たくさんのご応募をいただき、ありがとうございました。"); }))
}

@Page("/staff-recruitment")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun StaffRecruitmentPage() {
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/img/staff-recruitment.png", "Kotlin Fest 2026 当日スタッフ募集。11月14日開催、未経験歓迎。")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("当日スタッフの募集は終了しました") }) {
        org.jetbrains.compose.web.dom.Text("当日スタッフの募集は終了しました")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("たくさんのご応募をいただき、ありがとうございました。")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("p") {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("s") {
            org.jetbrains.compose.web.dom.Text("""11月14日（土）開催のKotlin Fest 2026を一緒につくる当日スタッフを募集します！""")
        }
    }

    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("p") {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("s") {
            org.jetbrains.compose.web.dom.Text("""未経験の方も歓迎です。見たいセッションがある場合は、できる範囲でシフトを調整します。""")
        }
    }

    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("h2") {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("s") {
            org.jetbrains.compose.web.dom.Text("""応募方法""")
        }
    }

    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("p") {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("s") {
            org.jetbrains.compose.web.dom.Text("""スタッフ業務の詳細や注意事項は、応募フォームをご確認ください。応募も同じフォームから受け付けています。""")
        }
    }

    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("class", "markdown-button");attr("aria-disabled", "true");attr("tabindex", "-1")}) {
            org.jetbrains.compose.web.dom.Text("当日スタッフ 応募フォーム")
        }
    }
}
